import { defaultAxios, IParams } from './base';

export interface IGetUserCert extends IParams {
  regidentNo: string[];
  custNm?: string;
  ctn?: string;
}

export const putUserCert = (params: any) => {
  return defaultAxios().put(`/loan/cert`, params);
};
